<template>
  <div v-if="showIntro" class="audi-intro" :class="[showIntro ? 'visible' : 'unvisible']">
    <div class="audi-intro__header">
      <img class="audi-intro__illustration" src="/audi-decision/img/intro.jpg" alt="">
    </div>
    <div class="audi-intro__container">
      <div class="audi-intro__wrapper">
        <h2 class="audi-intro__title">Trouvez le financement qui vous correspond</h2>
        <button class="audi-btn-black" @click="startQuestionsHandler"> Découvrir</button>
      </div>
    </div>
  </div>

  <template v-else>
    <div v-if="!userSolution" class="audi-decision visible">
      <div
        v-for="(question, qIndex) in questions"
        :key="qIndex"
        class="audi-decision__question-container"
        :class="[
          qIndex === decisionStep ? 'priority visible' : 'unvisible'
        ]"
      >
        <div class="audi-decision__left-panel">
          <audi-progress :progress-length="questions.length" :current-step="qIndex" @go-to="clickHandler" />
          
          <div class="audi-decision__container" :class="[qIndex === 0 && 'audi-decision__container--first']">
            <button
              v-if="qIndex !== 0"
              class="audi-btn-previous"
              @click="clickHandler(qIndex - 1)">
              <img src="./assets/back.svg" alt="">
              <span>Précédent</span>
            </button>
            
            <div class="audi-decision__question">
              <h3 class="audi-decision__question-title">{{ question.title }}</h3>
              <div class="audi-decision__cta-container">
                <button
                  v-for="(answer, aIndex) in question.answers"
                  :key="aIndex"
                  @click="questionHandler(answer)"
                  class="audi-btn-black"
                >
                  {{ answer }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="audi-decision__right-panel">
          <img class="audi-decision__illustration" :src="question.src" :alt="question.title">
        </div>
      </div>
    </div>

    <div v-else class="audi-solution visible">
      <div class="audi-solution__solution-container">
        <div class="audi-solution__left-panel">
          <img class="audi-solution__illustration" :src="userSolution.src" :alt="userSolution.title">
        </div>
        <div class="audi-solution__right-panel">
          <audi-answer :userSolution="userSolution" />
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import { questions, decisionTree } from './decision-tree'
import AudiProgress from './components/AudiProgress.vue'
import AudiAnswer from './components/AudiAnswer.vue'

export default {
  name: 'App',
  components: {
    AudiProgress,
    AudiAnswer,
  },
  data() {
    return {
      showIntro: true,
      questions,
      decisionStep: 0,
    }
  },
  computed: {
    userAnswers() {
      return this.questions.reduce((mAnswers, question) => {
        const qState = question.state
        if (qState) mAnswers.push(qState)
        return mAnswers
      }, [])
    },
    userSolution() {
      if (!this.userAnswers[4]) return null

      const [decisionZero, decisionOne, decisionTwo, decisionThree, decisionFour] = this.userAnswers
      return decisionTree[decisionZero][decisionOne][decisionTwo][decisionThree][decisionFour]
    },
  },
  methods: {
    questionHandler(answer) {
      this.questions[this.decisionStep].state = answer

      this.decisionStep++
    },
    clickHandler(step) {
      this.decisionStep = step
    },
    startQuestionsHandler() {
      this.showIntro = false
    }
  }
}
</script>

<style lang="scss">
.visible {
  opacity: 0;
  z-index: 1;

  animation: fadeIn .3s cubic-bezier(0.75, 0.02, 0.5, 1) forwards;
}

.unvisible {
  opacity: 0;
  z-index: 0;

  animation: fadeOut .3s cubic-bezier(0.75, 0.02, 0.5, 1) forwards;
}

.priority {
  z-index: 2;
}

.audi-intro {
  position: absolute;
  background-color: black;
  height: var(--app-height);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  > div {
    flex: 1;
    min-height: 50%;
  }

  &__illustration {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 70%;
  }

  &__title {
    font-size: var(--title);
    letter-spacing: .256rem;
    line-height: 3rem;
    max-width: 80%;
    text-align: center;

    @media (min-width: 768px) {
      max-width: 100%;
      line-height: 8rem;
    }
  }

  &__wrapper {
    height: 100%;
    display: grid;
    place-items: center;
    place-content: center;
    gap: 6rem;

    @media (min-width: 768px) {
      gap: 2rem;
    }
  }
}


.audi-decision {
  position: relative;
  overflow: hidden;
  height: var(--app-height);

  &__illustration {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__question-container {
    position: absolute;
    width: 100%;
    height: 100%;

    @media (min-width: 768px) {
      display: flex;
    }
  }

  &__question-title {
    font-family: AudiTypeExtended;
    font-size: var(--sub-title);
    line-height: 4rem;
    font-feature-settings: 'clig' off, 'liga' off;
  }

  &__cta-container {
    display: grid;
    margin: 0 auto;
    gap: 2rem;
    width: 300px;
  }

  &__left-panel,
  &__right-panel {

    @media (min-width: 768px) {
      width: 50%;
    }
  }

  &__right-panel {
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  }

  &__left-panel {
    position: relative;
    background-color: black;
    color: white;
    height: var(--app-height);
  }

  &__question {
    display: grid;
    text-align: center;
    gap: 4rem;

    @media (min-width: 768px) {
      max-width: 90%;
      margin: auto;
    }
  }

  &__container {
    padding-top: 6rem;
    margin: 0 40px;

    &--first {
      padding-top: 15rem;
    }
  }
}

.audi-solution {
  position: relative;
  overflow: hidden;
  height: var(--app-height);
  
  &__solution-container {
    @media (min-width: 768px) {
      display: flex;
    }
  }

  &__left-panel,
  &__right-panel {
    
    @media (min-width: 768px) {
      width: 50%;
    }
  }

  &__left-panel {
    display: none;
    position: relative;
    animation: slide .6s cubic-bezier(0.75, 0.02, 0.5, 1) forwards;
    
    @media (min-width: 768px) {
      display: block;
    }
  }

  &__right-panel {
    opacity: 0;
    animation: fadeIn .3s cubic-bezier(0.75, 0.02, 0.5, 1) forwards;
    animation-delay: .6s;
  }

  &__sub-title {
    margin-top: 52px;
    display: flex;
    justify-content: center;
    font-size: var(--paragraph);
  }

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }

  &__links-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  &__illustration {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 70%;
  }
}
</style>